// 
import WebComponent from '../src/webComponents/WebComponent';
import $ from 'jquery';
import '../edeeshop/jquery.product-list-slider';

export default class ProductListSlider extends WebComponent {
  enterDocument() {
    $(this.element).productListSlider();
  }
}



// WEBPACK FOOTER //
// ./node_modules/fg-frontend/components/ProductListSlider.js